import { RemoteGetAllActivitiesByPlace } from 'data/usecases';
import { GetAllActivitiesByPlace } from 'domain/usecases';
import { makeApiUrlActivitiesByPlace } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllActivitiesByPlace = (): GetAllActivitiesByPlace =>
  new RemoteGetAllActivitiesByPlace(
    makeApiUrlActivitiesByPlace(),
    makeAxiosHttpClient(),
  );
